import { logisticsClient } from '../services/logistics/LogisticsClient';
import { CustomerResponse } from '../services/logistics/types';
import { useQuery } from 'react-query';

export const useCustomer = (customerId: number, formVisible: boolean) => {
  const { data, error, isLoading } = useQuery<CustomerResponse>(
    ['customer', customerId, formVisible],
    async () => {
      if (!customerId) throw new Error('No customerId provided');
      const customer = await logisticsClient.getCustomer(customerId);
      return customer;
    },
    {
      enabled: !!customerId
    }
  );

  return {
    customer: data,
    error: !!error,
    loading: isLoading
  };
};
